export default __webpack_public_path__ + "static/media/copy.a8b0cc72.svg";